/**
 * 用户缓存工具类
 * 用于保存、获取和清除用户登录信息
 */
export default {

    /**
     * 保存Token信息到本地缓存
     * @param {String} token - 用户信息对象
     */
    saveTokenCache: function (token) {
        localStorage.setItem('token', token)
    },
    /**
     * 清理Token信息到本地缓存
     */
    clearTokenCache: function () {
        localStorage.removeItem('token');
    },
    /**
     * 保存用户信息到本地缓存
     * @param {Object} userData - 用户信息对象
     */
    saveUserCache: function (userData) {
        if (userData && typeof userData === 'object') {
            try {
                // 将用户对象转换为JSON字符串后保存
                const userDataStr = JSON.stringify(userData);
                localStorage.setItem('userInfo', userDataStr);
                console.log('用户数据已成功保存到缓存');
            } catch (e) {
                console.error('保存用户缓存失败:', e);
            }
        } else {
            console.warn('无效的用户数据格式，无法保存到缓存');
        }
    },

    /**
     * 从本地缓存获取用户信息
     * @returns {Object|null} - 用户信息对象或null
     */
    getUserCache: function () {
        try {
            // 获取JSON字符串并解析为对象
            const userDataStr = localStorage.getItem('userInfo');
            if (userDataStr) {
                return JSON.parse(userDataStr);
            }
            return {};
        } catch (e) {
            console.error('获取用户缓存失败:', e);
            return null;
        }
    },

    /**
     * 清除本地缓存中的用户信息
     */
    clearUserCache: function () {
        try {
            localStorage.removeItem('userInfo');
            console.log('用户缓存已清除');
        } catch (e) {
            console.error('清除用户缓存失败:', e);
        }
    },

    /**
     * 保存行为数据到本地缓存
     * @param {Object} behaviorData - 行为数据对象
     */
    saveBehaviorData: function (behaviorData) {
        if (behaviorData && typeof behaviorData === 'object') {
            try {
                // 将行为数据对象转换为JSON字符串后保存
                const behaviorDataStr = JSON.stringify(behaviorData);
                localStorage.setItem('behaviorData', behaviorDataStr);
                console.log('行为数据已成功保存到缓存');
            } catch (e) {
                console.error('保存行为数据缓存失败:', e);
            }
        } else {
            console.warn('无效的行为数据格式，无法保存到缓存');
        }
    },

    /**
     * 从本地缓存获取行为数据
     * @returns {Object|null} - 行为数据对象或null
     */
    getBehaviorData: function () {
        try {
            // 获取JSON字符串并解析为对象
            const behaviorDataStr = localStorage.getItem('behaviorData');
            if (behaviorDataStr) {
                return JSON.parse(behaviorDataStr);
            }
            return null;
        } catch (e) {
            console.error('获取行为数据缓存失败:', e);
            return null;
        }
    },

    /**
     * 清除本地缓存中的行为数据
     */
    clearBehaviorData: function () {
        try {
            localStorage.removeItem('behaviorData');
            console.log('行为数据缓存已清除');
        } catch (e) {
            console.error('清除行为数据缓存失败:', e);
        }
    }
};